import React, { createContext, useContext } from 'react';

/**
 * Context for managing card operations like reset and animate
 * This allows the modal to control cards without storing functions in Redux
 */
interface CardManagementContextType {
  resetCard: (actionId: string) => void;
  animateReject: (
    actionId: string,
    rejectionData?: {
      rejection_reason?: string;
      rejection_payload?: Record<string, any>;
    },
  ) => void;
  animateAccept: (actionId: string, updatedPayload?: any) => void;
}

const CardManagementContext = createContext<CardManagementContextType | null>(null);

export const useCardManagement = () => {
  const context = useContext(CardManagementContext);
  if (!context) {
    throw new Error('useCardManagement must be used within a CardManagementProvider');
  }
  return context;
};

export const CardManagementProvider: React.FC<{
  children: React.ReactNode;
  resetCard: (actionId: string) => void;
  animateReject: (
    actionId: string,
    rejectionData?: {
      rejection_reason?: string;
      rejection_payload?: Record<string, any>;
    },
  ) => void;
  animateAccept: (actionId: string, updatedPayload?: any) => void;
}> = ({ children, resetCard, animateReject, animateAccept }) => {
  return (
    <CardManagementContext.Provider value={{ resetCard, animateReject, animateAccept }}>
      {children}
    </CardManagementContext.Provider>
  );
};
